export class Pair {
   key: any;
   value: any;

    constructor(key: any, value: any) {
        this.key=key;
        this.value = value;
    }

   static getValueFromList(list: Pair[], key: string): string {
     if (list==null || list.length==0 || key==null) {
        return null!;
     }
     for (let i = 0; i< list.length; i++) {
        if (list[i].key==key) {
           return list[i].value;
        }
     }
     return null!;
   }

   static removeValueFromList(list: Pair[], key: string): void {
     if (list==null || list.length==0 || key==null) {
        return;
     }
     for (let i = 0; i< list.length; i++) {
        if (list[i].key==key) {
           list.splice(i, 1);
           return;
        }
     }
   }

   static includes(list: Pair[], item: Pair): boolean {
     return (Pair.indexOf(list, item)!=-1);
   }

   static indexOf(list: Pair[], item: Pair): number {
     if (list==null || list.length==0 || item==null) {
        return -1;
     }
     for (let i = 0; i< list.length; i++) {
        if (list[i].key==item.key) {
           return i;
        }
     }
     return -1;
   }

   static getKeys(list: Pair[]): any[] {
     let res: any[] = [];
     if (list==null || list.length==0) {
        return res;
     }
     for (let i = 0; i< list.length; i++) {
        res.push(list[i].key);
     }
     return res;
   }

   static getValues(list: Pair[]): any[] {
     let res: any[] = [];
     if (list==null || list.length==0) {
        return res;
     }
     for (let i = 0; i< list.length; i++) {
        res.push(list[i].value);
     }
     return res;
   }

}
